import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import filterTypes from "data/filter-types";
import findFilterValue from "helpers/find-filter-value";
import searchOperationGenerator from "helpers/search-operation-generator";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import {
  triggerFilters,
  triggerGetActions
} from "actions/bike-scan-trigger/actions";

class Filters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filters: {}
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);

    this.props.triggerFilters();
    this.props.triggerGetActions();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.totalCount !== this.props.totalCount) {
      return true;
    } else if (nextState.isOpen !== this.state.isOpen) {
      return true;
    } else if (!_.isEqual(nextState.filters, this.state.filters)) {
      return true;
    } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
      return true;
    } else if (!_.isEqual(nextProps.actions, this.props.actions)) {
      return true;
    }
    return false;
  }

  handleSearch = () => {
    const { filters } = this.state;
    const filtersToArray = [];
    Object.keys(filters)
      .forEach(name => {
        if (Object.keys(filters[name]).length) {
          filtersToArray.push(filters[name]);
        }
      });
    this.props.handleSearch(filtersToArray);
  };

  handleReset = () => {
    this.setState({
      filters: {}
    }, this.props.handleReset);
  };

  handleChangeFilter = (name, valueObject) => {
    const { filters } = this.state;
    filters[name] = valueObject;
    this.setState({
      filters
    });
  };

  render() {
    const {
      activeFilters,
      totalCount,
      filters,
      actions
    } = this.props;
    const {
      isOpen
    } = this.state;

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title={
            <div>
              Bike Scan Trigger
              <button
                className="btn btn-success btn-sm ml-2"
                onClick={this.props.handleCreate}
                title="Create new trigger"
              >
                <FontAwesomeIcon icon={faPlus}/>
              </button>
            </div>
          }
          totalCount={totalCount}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
        />
        <Card.Body className="p-0">
          <Collapse in={isOpen} className="p-3" timeout={0}>
            <div className="row">
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="id"
                  placeholder="ID"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.id, [filterTypes.EQUALS.value])}
                  value={findFilterValue("id", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="name"
                  placeholder="Name"
                  filterType="text"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.name, [filterTypes.LIKE.value])}
                  value={findFilterValue("name", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="userId"
                  placeholder="User ID"
                  filterType="text"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.userId, [filterTypes.EQUALS.value])}
                  value={findFilterValue("userId", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="qr"
                  placeholder="Bike QR"
                  filterType="text"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.qr, [filterTypes.EQUALS.value])}
                  value={findFilterValue("qr", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="reason"
                  placeholder="Reason"
                  filterType="text"
                  onChange={this.handleChangeFilter}
                  searchOperation={filters.reason || [filterTypes.LIKE.value]}
                  value={findFilterValue("reason", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="description"
                  placeholder="Description"
                  filterType="text"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.description, [filterTypes.LIKE.value])}
                  value={findFilterValue("description", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="actions"
                  placeholder="Actions"
                  filterType="select_multiple"
                  filterTypeOptions={actions.map(value => ({
                    label: value,
                    value
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.actions, [filterTypes.IN.value])}
                  value={findFilterValue("actions", activeFilters)}
                />
              </div>

              <div className="col-12 col-md-3 mb-3">
                <div className="d-flex justify-content-between justify-content-md-end">
                  <button
                    className="btn btn-warning btn-sm ml-2"
                    onClick={this.handleReset}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-success btn-sm ml-2"
                    onClick={this.handleSearch}
                  >
                    Load
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    );
  }
}

Filters.defaultProps = {
  activeFilters: []
};

Filters.propTypes = {
  activeFilters: PropTypes.array.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  handleCreate: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  filters: state.bikeScanTrigger.filters,
  actions: state.bikeScanTrigger.actions,
});

const mapStateToDispatch = dispatch => ({
  triggerFilters: bindActionCreators(triggerFilters, dispatch),
  triggerGetActions: bindActionCreators(triggerGetActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Filters);



// WEBPACK FOOTER //
// ./src/views/pages/bikes-scan-trigger/filters.js